
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import InvestmentGuide from "./InvestmentGuide";

const ContactSection = () => {
  return (
    <Card className="mt-8 bg-gradient-to-r from-blue-50 to-yellow-50">
      <CardHeader>
        <CardTitle>Need More Information?</CardTitle>
        <CardDescription>
          Contact our investment team for detailed due diligence packages and bidding assistance.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col md:flex-row gap-4">
          <Button className="bg-blue-600 hover:bg-blue-700">
            Schedule Consultation
          </Button>
          <InvestmentGuide />
        </div>
      </CardContent>
    </Card>
  );
};

export default ContactSection;
